import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import toast, { Toaster } from "react-hot-toast";
import TagManager from "react-gtm-module";
import useDocumentTitle from "../../useDocumentTitle";
import { Redirect, useHistory } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import axios from "axios";
import Cookies from 'js-cookie';

import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";
import sendLeadToCrm from "../utils/sendLeadToCrm";

const Modal_started = ({ setIsOpen }) => {
  
  useDocumentTitle("Invu POS | Get demo app ");

  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [language, setLenguage] = useState("es");
  const [registrationId, setRegistrationId] = useState(null);

  const onChangeLanguaje = () => {
    i18n.changeLanguage(language);
    if (language === "es") {
      setLenguage("en");
    } else {
      setLenguage("es");
    }
  };

  // TagManager.dataLayer({
  //   dataLayer: {
  //     event: "pageview",
  //     path: useDocumentTitle,
  //   },
  // });

  const storedCountry =
  typeof window !== "undefined"
    ? localStorage.getItem("selectedCountry") || ""
    : "";

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const leadStatus = "Nuevo"

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const history = useHistory();

  const location = useLocation();
  const prefix = useLocalePrefix();
  const [countryRender, setCountryRender] = useState('');
  const [loading, setLoading] = useState(true); 
  const [country, setCountry] = useState(''); 

  const [geoInfo, setGeoInfo] = useState({
    ip: '',
    countryName: '',
    countryCode: '',
    city: '',
    timezone: ''
  }); 

  const getGeoInfo = (country) => {
    axios
      .get('https://ipapi.co/json/')
      .then((response) => {
        const data = response.data;
        setGeoInfo({
          ip: data.ip,
          countryName: data.country_name,
          countryCode: data.country_calling_code,
          city: data.city,
          timezone: data.timezone
        });
        // setCountryRender(data.country_name);
        setCountry(country != null ? country : data.country_name);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
      
  };
  
  const compareCountry = (a, b) => a.toLowerCase() === b.toLowerCase();

  useEffect(() => {
    var country = null
    if (lang.toLowerCase() === 'mexico' || lang.toLowerCase() === 'venezuela' || lang.toLowerCase() === 'elsalvador' || lang.toLowerCase() === 'costarica' || lang.toLowerCase() === 'colombia' || lang.toLowerCase() === 'guatemala' || lang.toLowerCase() === 'republicadominicana') {
      country = lang;
    }
    getGeoInfo(country);
  }, []);

  if (loading) {
    return <div></div>;
  }

  function generateUUID() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  var hutkValue = generateUUID();

  const handleSubmit = (evt) => {
    evt.preventDefault();
    const crmRequestId = sendLeadToCrm({
      firstName,
      lastName,
      email,
      phone,
      company: name,
      message,
      country: country,
      formName: "Formulario de Mercadeo",
    });
    var xhr = new XMLHttpRequest();
    var url =
      "https://api.hsforms.com/submissions/v3/integration/submit/3797225/be316fe8-ea4c-4aa2-ad2a-b5750f006e01";


    var data = {
      fields: [
        {
          name: "firstname",
          value: firstName,
        },
        {
          name: "lastname",
          value: lastName,
        },
        {
          name: "email",
          value: email,
        },
        {
          name: "mobilephone",
          value: phone,
        },
        {
          name: "name",
          value: name,
          objectTypeId: "COMPANY",
        },
        {
          name: "message",
          value: message,
        },
        {
          name: "hs_lead_status",
          value: leadStatus,
          objectTypeId: "CONTACT",
        }
      ],
      context: {
        hutk: hutkValue,
        ipAddress: geoInfo.ip,
        pageUri: "www.invupos.com",
        pageName: "Formulario de Mercadeo"
      },
    };
    console.log(data);
    var final_data = JSON.stringify(data);

    xhr.open("POST", url);
    // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        setIsOpen(false);
        const responseData = JSON.parse(xhr.responseText);
        const registrationId = responseData.inlineMessage;

        history.push(`${prefix}/request-demo-confirmed`, {
          firstName,
          lastName,
          email,
          phone,
          name,
          message,
          leadStatus,
          registrationId,
          hutkValue,
          crmRequestId,
        });
        toast.custom((t) => (
          <div
            className={`${
              t.visible ? "animate-enter" : "animate-leave"
            } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
          >
            <div className="flex-1 w-0 p-4"> 
              <div className="flex items-start">
                <div className="flex-shrink-0 pt-0.5">
                  <img
                    className="h-10 w-10 rounded-full"
                    src="https://img.invupos.com/webinvu/Contact/Layer_2_pxylmq.png"
                    alt=""
                  />
                </div>
                <div className="ml-3 flex-1">
                  <p className="text-sm font-medium text-gray-900">Invu POS</p> 
                  <p className="mt-1 text-sm text-gray-500">
                    <span className="font-semibold text-green-600">
                      Message sent.
                    </span>{" "}
                    We will communicate soon📭
                  </p>
                </div>
              </div>
            </div>
            <div className="flex border-l border-gray-200">
              <button
                onClick={() => toast.dismiss(t.id)}
                className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                Close
              </button>
            </div>
          </div>
        ));
        

        setTimeout(() => {
          toast.dismiss(); 
        }, 8000);
        // alert(xhr.responseText);
      } else if (xhr.readyState === 4 && xhr.status === 403) {
        console.log(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.
      } else if (xhr.readyState === 4 && xhr.status === 404) {
        console.log(xhr.responseText);
        toast.custom((t) => (
          <div
            className={`${
              t.visible ? "animate-enter" : "animate-leave"
            } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
          >
            <div className="flex-1 w-0 p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0 pt-0.5">
                  <img
                    className="h-10 w-10 rounded-full"
                    src="https://img.invupos.com/webinvu/Contact/Layer_2_pxylmq.png"
                    alt=""
                  />
                </div>
                <div className="ml-3 flex-1">
                  <p className="text-sm font-medium text-gray-900">Invu POS</p>
                  <p className="mt-1 text-sm text-gray-500">
                    <span className="font-semibold text-red-600">Error</span>{" "}
                    Bad request ❌
                  </p>
                </div>
              </div>
            </div>
            <div className="flex border-l border-gray-200">
              <button
                onClick={() => toast.dismiss(t.id)}
                className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                Close
              </button>
            </div>
          </div>
        ));
      }
    };
    // Sends the request
    xhr.send(final_data);
    clearForm();
  };

  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setMessage("");
    setName("");
    setIsChecked(false); // Limpia el checkbox
  };

  const logos = [
    "https://img.invupos.com/invu%20mexico/clientes/Little%20Caesars.png",
    "https://www.clutch.com/wp-content/uploads/2020/04/krispy-kreme-logo-white.png",
    "https://img.invupos.com/invu%20mexico/clientes/Olivegardenlogo.webp",
    "https://img.invupos.com/invu%20mexico/clientes/cinnabon-logo.png",
    "https://img.invupos.com/invu%20costa%20rica/images/bbq%20chicken.png",
    "https://img.invupos.com/invu%20costa%20rica/images/cafeunido_logo.png",
    "https://img.invupos.com/invu%20costa%20rica/images/Krume.png",
    "https://img.invupos.com/invu%20costa%20rica/images/manglebar.png",
    "https://img.invupos.com/invu%20costa%20rica/images/pedromandinga.png",
    "https://img.invupos.com/webinvu/Clients%20cr/sociatel.png",
    "https://img.invupos.com/webinvu/Clients%20cr/Lofe.png",
    "https://img.invupos.com/invu%20costa%20rica/images/thelookout_logo_white.png",
    "https://img.invupos.com/invu%20costa%20rica/images/HotelBananaAzul.png",
    "https://img.invupos.com/invu%20costa%20rica/images/bardo_logo.png",
    "https://img.invupos.com/webinvu/Clients%20mx/Izlah.png",
    "https://img.invupos.com/webinvu/Clients%20mx/El%20tizoncito.png",
    "https://img.invupos.com/webinvu/Clients%20mx/TACOS%20MANOLO.png",
    "https://img.invupos.com/invu%20mexico/clientes/cinnabon-logo.png",
    "https://img.invupos.com/webinvu/Clients%20mx/Perfumes%20Europeos.png",
    "https://img.invupos.com/invu%20mexico/clientes/despechomx-logo-transformed.png",
    "https://img.invupos.com/invu%20mexico/clientes/blendstationphoto.jpg"
  ];
  

// Se duplican solo una vez para la animación, es suficiente.
const allLogos = [...logos, ...logos]; 


  return (
    <>
      {compareCountry(storedCountry, 'Mexico') || compareCountry(storedCountry, 'mexico') ? (
  <div className="flex justify-center flex overflow-x-hidden overflow-y-auto z-50 inset-0 fixed h-screen items-center antialiased bg-gray-500 bg-opacity-75 transition-opacity ">
    <div className="flex flex-col w-11/12 sm:w-5/6 xl:w-[500px] lg:w-2/5 md:w-2/4 max-w-2xl mx-auto rounded-lg border border-gray-300 shadow-xl">
      
       <form className="bg-white">
            <div class="flex flex-row justify-between p-6 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-l">
              <p class="font-semibold text-gray-800">Contacto Mexico</p>
              <button onClick={() => setIsOpen(false)}>
                <svg
                  class="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
            <iframe
              src="https://forms.monday.com/forms/embed/3057840758763ef17fb0d887a1b6a4d3?r=use1"
              width="100%"
              height="750"
              style={{
                border: '0',
                boxShadow: '5px 5px 56px 0px rgba(0,0,0,0.25)',
                margin: '0px',
                padding: '0px',
              }}
              title="Monday Form"
            ></iframe> 
        </form>
    </div>
  </div>
) : (
    <div className="fixed inset-0 z-50 flex h-screen items-center justify-center overflow-y-auto overflow-x-hidden bg-gray-600 bg-opacity-75 antialiased p-2">
        <div className="w-full max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden shadow-xl">

          {/* 🟦 COLUMNA IZQUIERDA (NUEVA) */}
          <div className="hidden lg:flex relative flex-col items-center justify-end p-8 text-center overflow-hidden">

          {/* Imagen de fondo */}
          <img
            src="https://img.invupos.com/webinvu/modal/form-contact-cover-2%20%281%29.png"
            alt="Fondo"
            className="absolute inset-0 h-full w-full object-cover -z-10"
          />

          {/* Overlay oscuro opcional (recomendado para mejor contraste) */}
          <div className="absolute inset-0 -z-10"></div>

          {/* Contenido */}
          <h3 className="mb-3 text-sm font-semibold text-white uppercase tracking-wider">
            Nuestros Clientes Confían
          </h3>

          <div className="slider-container">
            <div className="slider-track">
              {allLogos.map((logoSrc, index) => (
                <div
                  key={index}
                  className="m-2 flex h-14 w-24 flex-shrink-0 items-center justify-center rounded-lg bg-[#003CB0] shadow-md"
                >
                  <img
                    src={logoSrc}
                    alt={`Logo ${index + 1}`}
                    className="max-h-full max-w-full object-contain p-2"
                  />
                </div>
              ))}
            </div>
          </div>

          <p className="mt-4 text-sm text-white/80">
            Descubre cómo Invu POS ayuda a negocios como el tuyo.
          </p>
          </div>

          <div className="bg-white">
          <form onSubmit={handleSubmit}>
            <div class="flex flex-row justify-between p-6 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg">
              <p class="text-2xl font-bold text-indigo-600">{t("modaltrydemo")}</p>
              <button onClick={() => setIsOpen(false)}>
                <svg
                  class="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="flex flex-col px-6 py-5  bg-white">
             
              <div class="flex flex-col mt-6 sm:flex-row items-center mb-3 sm:space-x-5">
                <div class="w-full sm:w-1/2">
                  <div>
                    <label class="sr-only" for="firstname">
                      First name
                    </label>
                    <input
                      className="h-12 w-full rounded-full border border-gray-200 bg-transparent pl-4 text-gray-600 placeholder-gray-400 shadow-sm" 
                      placeholder={t("modalfirstname")}
                      required
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                </div>
                <div class="w-full sm:w-1/2 mt-2 sm:mt-0">
                  <div>
                    <label class="sr-only" for="firstname">
                      Last name
                    </label>
                    <input
                      className="h-12 w-full rounded-full border border-gray-200 bg-transparent pl-4 text-gray-600 placeholder-gray-400 shadow-sm" 
                      placeholder={t("modallastname")}
                      required
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div class="flex flex-col sm:flex-row items-center mb-3 sm:space-x-5">
                <div class="w-full sm:w-1/2">
                  <div>
                    <label class="sr-only" for="firstname">
                      Email
                    </label>
                    <input
                      className="h-12 w-full rounded-full border border-gray-200 bg-transparent pl-4 text-gray-600 placeholder-gray-400 shadow-sm" 
                      placeholder={t("modalemail")}
                      required
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div class="w-full sm:w-1/2 mt-2 sm:mt-0">
                  <div>
                    <label class="sr-only" for="firstname">
                      Phone
                    </label>
                    {/* <input
                      class="w-full p-4 bg-white border border-gray-200 rounded shadow-sm"
                      placeholder={t("modalphone")}
                      required
                      type="text"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    /> */}
                    <PhoneInput
                      className="h-12 w-full rounded-full border border-gray-200 bg-transparent pl-4 text-gray-600 placeholder-gray-400 shadow-sm" 
                      placeholder={t("modalphone")}
                      defaultCountry={
                        compareCountry(storedCountry, 'Mexico') || compareCountry(storedCountry, 'mexico') ? "MX" : 
                        compareCountry(storedCountry, 'Venezuela') || compareCountry(storedCountry, 'venezuela') ? "VE" :
                        compareCountry(storedCountry, 'Elsalvador') || compareCountry(storedCountry, 'elsalvador') ? "SV" :
                        compareCountry(storedCountry, 'Costarica') || compareCountry(storedCountry, 'costarica') ? "CR" :
                        compareCountry(storedCountry, 'Colombia') || compareCountry(storedCountry, 'colombia') ? "CO" :
                        compareCountry(storedCountry, 'Guatemala') || compareCountry(storedCountry, 'guatemala') ? "GT" :
                        compareCountry(storedCountry, 'Republicadominicana') || compareCountry(storedCountry, 'republicadominicana') ? "DO" :
                        compareCountry(storedCountry, 'Unitedstates') || compareCountry(storedCountry, 'unitedstates') ? "US" :
                        compareCountry(storedCountry, 'Trinidadytobago') || compareCountry(storedCountry, 'trinidadytobago') ? "TT" :
                        "PA"
                      }
                      required
                      value={phone}
                      onChange={(value) => setPhone(value)}
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label class="sr-only" for="firstname">
                  Company
                </label>
                <input
                 className="h-12 w-full rounded-full border border-gray-200 bg-transparent pl-4 text-gray-600 placeholder-gray-400 shadow-sm" 
                  placeholder={t("modalcompany")}
                  required
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <textarea
                // type="message"
                placeholder={t("modalmessage")}
                className="mb-2 h-24 w-full rounded-xl border border-gray-200 bg-transparent p-4 shadow-sm resize-y"
                required
                type="text"
                value={message}
                maxLength={250}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
               <p className="text-xs text-gray-500 text-right">
                  {message.length}/250
                </p>


              <div class="mt-6 mb-2 text-left text-gray-600 dark:text-gray-400 flex items-center justify-between">
                <div class="flex items-center">
                  <input  type="checkbox" checked={isChecked} onChange={handleCheckboxChange} placeholder="Privacy Policy" required class="w-5 h-5  text-blue-600 border-gray-200 rounded focus:ring-blue-500"/>
                  <label  class="block ml-2 text-[14px] text-neutral-600"> 
                  {t("privacypolicytext1")} {" "}
                  <Link
                    className={`underline font-bold ${countryRender === 'Mexico' ? 'text-green-700' : countryRender === 'Venezuela' ? 'text-[#001F7E]' : 'text-indigo-600'}`}
                    to={`${[prefix]}` + "/politicas-de-privacidad"}
                    onClick={() => {window.scrollTo(0, 0); setIsOpen(false);}}
                  >
                    {t("privacypolicytexthref2")}
                  </Link>
                    {" "}
                      {t("privacypolicytext3")}
                  </label>
                </div>
              </div>
            </div>


            <div class="flex flex-row items-center justify-between p-5 bg-white border-t border-gray-200 rounded-bl-lg rounded-br-lg">
              <p
                onClick={() => setIsOpen(false)}
                class="font-semibold text-gray-600 cursor-pointer"
              >
                {t("modalformbuttoncancel")}
              </p>
              {/* <button
                type="submit"
                value="Submit"
                className="inline-flex items-center px-8 py-3 text-white bg-indigo-600 border border-indigo-600 rounded hover:bg-transparent hover:text-indigo-600 active:text-indigo-500 focus:outline-none focus:ring"
              >
                <span class="text-sm font-medium">{t("modalformbutton")}</span>
              </button> */}
              <button
                type="submit"
                value="Submit"
                className={`inline-flex items-center px-8 py-3 ${countryRender === 'Mexico' ? 'bg-green-700 text-white' : countryRender === 'Venezuela' ? 'text-[#000000] bg-[#FED850]' : 'bg-indigo-600 text-white'} border rounded hover:opacity-90`}
              >
                <span className="text-sm font-medium">{t("modalformbutton")}</span>
              </button>
            </div>
          </form>
          </div>
          <Toaster position="bottom-center" reverseOrder={false} />
        </div>
      </div>
      )}
    </>
  );
};

export default Modal_started;